module.exports = __webpack_public_path__ + "static/media/HindVadodara-Bold.832e3097.woff2";